/* global axios */
import ApiClient from './ApiClient';

class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('message_templates', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }

  analytics(templateId, { days = 30 } = {}) {
    return axios.get(`${this.url}/${templateId}/analytics`, {
      params: { days },
    });
  }
}

export default new MessageTemplatesAPI();
